export const PERSISTED_AT_SET_VALUE = 'roaCarInsurance/setValue/persistedAt';

export const setPersistedAtValue = () => ({ type: PERSISTED_AT_SET_VALUE });
